export const AREAS = [
    "Sistemas",
    "Recursos humanos",
    "Gerencia",
    "Administración",
    "Operaciones",
    "Ventas",
    "Logística",
    "Jurídico",
    "Mantenimiento"
];
